import PropTypes from 'prop-types';

import doorDashLogo from 'assets/doorDash.png';
import noAudit from 'assets/noAudits.png';
import spotifyLogo from 'assets/spotify.png';
import wiseLogo from 'assets/wise.png';

import styles from './EmptyDashboardState.module.scss';

const SAMPLE_AUDITS = [
  {
    id: 'doordash',
    logo: doorDashLogo,
    description: 'The DoorDash home transformed into an AI-driven personalized experience',
    url: 'https://dev.onbeacon.ai/share/d8AJuv_8F5DU1aM8U901ncslRQJAa95t-d3ffpuCPxw',
  },
  {
    id: 'spotify',
    logo: spotifyLogo,
    description: 'Creating a personalized listening entry point inside the Spotify home',
    url: 'https://dev.onbeacon.ai/share/cJKhFBaqklp-61plAk0H0yTpBRzicYU1pF7E71Mkk7g',
  },
  {
    id: 'wise',
    logo: wiseLogo,
    description: 'Turning the balance in the Wise mobile app into a dynamic action hub',
    url: 'https://dev.onbeacon.ai/share/cJKhFBaqklp-61plAk0H0yTpBRzicYU1pF7E71Mkk7g',
  },
];

const EmptyDashboardState = ({ onCreateAudit, onOpenProductLibrary }) => {
  const handleSampleAuditClick = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={styles.container}>
      <div className={styles.empty}>
        <img src={noAudit} alt="" className={styles.image} />

        <div className={styles.copy}>
          <h2 className={styles.title}>
            No audits yet
          </h2>
          <p className={styles.subtitle}>
            Start by adding flows to your library or create your first audit
          </p>
        </div>

        <div className={styles.buttons}>
          <button
            type="button"
            className={styles.secondaryButton}
            onClick={onOpenProductLibrary}
          >
            Product library
          </button>
          <button
            type="button"
            className={styles.primaryButton}
            onClick={onCreateAudit}
          >
            New audit
          </button>
        </div>
      </div>

      <div className={styles.sampleAudits}>
        <p className={styles.sampleAuditsTitle}>
          Not sure where to start? Check these audits to get inspired
        </p>

        <div className={styles.cards}>
          {SAMPLE_AUDITS.map(audit => (
            <button
              key={audit.id}
              type="button"
              className={styles.card}
              onClick={() => handleSampleAuditClick(audit.url)}
            >
              <img src={audit.logo} alt="" className={styles.logo} />
              <div className={styles.cardContent}>
                <p className={styles.description}>
                  {audit.description}
                </p>
                <svg
                  className={styles.externalIcon}
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.3333 3.33334H16.6666V6.66668M16.6666 3.33334L10 10M16.6666 11.6667V15.8333C16.6666 16.2754 16.491 16.6993 16.1785 17.0118C15.8659 17.3244 15.442 17.5 15 17.5H4.16663C3.72459 17.5 3.30068 17.3244 2.98812 17.0118C2.67556 16.6993 2.49996 16.2754 2.49996 15.8333V5.00001C2.49996 4.55798 2.67556 4.13407 2.98812 3.82151C3.30068 3.50894 3.72459 3.33334 4.16663 3.33334H8.33329"
                    stroke="#8F97A5"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

EmptyDashboardState.propTypes = {
  onCreateAudit: PropTypes.func.isRequired,
  onOpenProductLibrary: PropTypes.func.isRequired,
};

export default EmptyDashboardState;
